/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { CSSProperties } from 'react';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    chainedInputName: string;
    flowType?: 'Source' | 'Target';
    chainedFlowStyles: CSSProperties;
    typographyClass?: string;
}

const ChainedContentFlow = (props: commonTypes.WidgetInstanceProps): JSX.Element => {
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { styles, chainedInputName, flowType, chainedFlowStyles } = widgetProperties || {};
    const { data } = props;
    const { inEditMode, Placeholder } = commonHooks.useAppContext();
    const chainedContentStyles = css`
        div[data-region-flow-into=${chainedInputName}] {
            -ro-flow-into: ${chainedInputName}contentFlow content;
        }

        .hide {
            display: none;
        }

        div[data-region-flow-from=${chainedInputName}] {
            -ro-flow-from: ${chainedInputName}contentFlow;
        }
    `;

    return (
        <div
            className={`carousel ${
                widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
            }`}
            css={css`
                ${chainedContentStyles}${getTextSchemaProperties(
                    widgetProperties,
                    data?.colorSpace
                )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                    widgetProperties
                )}${styles || ''}
            `}
        >
            <div id="ContentFlow">
                {flowType === 'Source' && (
                    <div
                        className={!inEditMode ? `hide` : ''}
                        data-region-flow-into={chainedInputName}
                    >
                        <Placeholder
                            data={data}
                            contentPlaceHolderId="children"
                            parentWidgetInstanceId={props.widgetInstanceId || ''}
                        />
                    </div>
                )}
                <div style={chainedFlowStyles} data-region-flow-from={chainedInputName}>
                    &nbsp;
                </div>
            </div>
        </div>
    );
};

export default ChainedContentFlow;
